import utils from '@/mixins/utils'

export function filtro(cadastros, exibirVermelhos, exibirVerdes) {
  let cadastros_filtrados = cadastros

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.ultimo_acompanhamento == null) {
        return true
      }
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.ultimo_acompanhamento != null) {
        return true
      }
    })
  }

  return cadastros_filtrados
}

export function handleGroupFilter(data, group) {
  if (data.length > 0) {
    let filtrado = data.filter((item) => {
      if (group === 'ativos') {
        return item.saiu == '3' && item.outra_equipe == '0'
      } else if (group === 'outra-equipe') {
        return item.outra_equipe == '1'
      } else if (group === 'obitos') {
        return item.saiu == '1'
      } else if (group === 'mudou-se') {
        return item.saiu == '2'
      } else if (group === 'atendimento-recente') {
        return item.atend_pos_saiu == '1'
      } else {
        return item
      }
    })
    return filtrado
  }
}
